module.exports = __webpack_public_path__ + "img/push-img.b741a28c.svg";